/**
 * External destinations that appear on more than one surface.
 *
 * "Talk to sales" was previously pointing at three different places depending
 * on where you clicked it — the in-app /demo/book page in the header, and two
 * different Calendly links elsewhere — so the same label produced a different
 * booking experience per page. One constant, one destination.
 */
export const TALK_TO_SALES_URL = 'https://calendly.com/tonyennis/see-giga-in-action-clone';
